import * as React from 'react'
import { Link, } from 'react-router-dom';

import { iconLinkBase, ACCOUNT_MANAGEMENT, SECTION_NAME_TO_ICON_URL, } from './shared'

import { ButtonSpinner } from '../../../Shared'

export const LOG_IN_AS_A_TEACHER = "Log in as a Teacher"

export const accountManagementTiles = [
  {
    name: 'Manage Accounts',
    link: '/teachers/premium_hub/account_management',
    icon: `${iconLinkBase}/manage-accounts.svg`,
    linkText: 'Manage accounts',
    description: 'Create new accounts, manage admins, and more.',
  },
  {
    name: LOG_IN_AS_A_TEACHER,
    icon: `${iconLinkBase}/log-in-as-a-teacher.svg`,
    description: 'Access each teacher’s account to assign activities, manage rosters, and view data.',
  },
  {
    name: 'Manage Subscriptions',
    link: '/teachers/premium_hub/school_subscriptions',
    linkText: 'Manage subscriptions',
    icon: `${iconLinkBase}/manage-subscriptions.svg`,
    description: 'View subscription history, manage subscriptions, and more.',
  }
]

const AccountManagementSection = ({ handleClickLogInAsATeacher, loading, }) => {
  let logInAsTeacherButton = <button className="quill-button outlined medium grey focus-on-light" onClick={handleClickLogInAsATeacher} type="button">Log in as a teacher</button>

  if (loading) {
    logInAsTeacherButton = <button className="quill-button outlined medium grey focus-on-light disabled" disabled={true} type="button">Log in as a teacher <ButtonSpinner variant="dark" /></button>
  }

  const tiles = accountManagementTiles.map(tile => {
    return (
      <div className="tile" key={tile.name}>
        <div>
          <h3>{tile.name}</h3>
          <p>{tile.description}</p>
        </div>
        <div className="link-and-image">
          {tile.name === LOG_IN_AS_A_TEACHER ? logInAsTeacherButton : <Link className="quill-button outlined medium grey focus-on-light" to={tile.link}>{tile.linkText}</Link>}
          <img alt="" src={tile.icon} />
        </div>
      </div>
    )
  })

  return (
    <section aria-labelledby="accountManagementSectionTitle" className="overview-section-wrapper account-management">
      <h2 id="accountManagementSectionTitle">
        <img alt="" src={SECTION_NAME_TO_ICON_URL[ACCOUNT_MANAGEMENT]} />
        <span>{ACCOUNT_MANAGEMENT}</span>
      </h2>
      <div className="overview-section">
        <div className="overview-section-content">
          {tiles}
        </div>
      </div>
    </section>
  )
}

export default AccountManagementSection
